const messages = {
  threads: {
    orders: {
      title: "A sua encomenda na loja de recompensas",
      content:
        "Caro cliente BRIDGESTONE PLUS,<br/>Obrigado pela sua encomenda na loja de recompensas!<br/>A sua encomenda está agora a ser processada.<br/>Tempo estimado de entrega 7 y 15 dias/semanas.",
    },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "O seu registo foi aprovado",
      content:
        "Caro utilizador BRIDGESTONE PLUS,<br/>O seu registo na BRIDGESTONE PLUS foi verificado e aprovado.<br/>Já poderá desfrutar de tudo que temos para lhe oferecer em BRIDGESTONE PLUS.<br/>Um brinde à continuação de uma boa colaboração!<br/>A sua equipa BRIDGESTONE PLUS",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "O seu registo foi aprovado",
      content:
        "Caro utilizador BRIDGESTONE PLUS,<br/>O seu registo na BRIDGESTONE PLUS foi verificado e aprovado.<br/>Já poderá desfrutar de tudo que temos para lhe oferecer em BRIDGESTONE PLUS.<br/>Um brinde à continuação de uma boa colaboração!<br/>A sua equipa BRIDGESTONE PLUS",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
    indirectAccepted: {
      title:
        "Bridgestone Plus Rewards: Aceitação dos Termos e Condições / Política de Privacidade",
      content:
        "Caro usuário Bridgestone Plus,<br/>Obrigado por aceitar os “Termos e Condições” assim como a “Política de Privacidade” de participação. Esperamos que a plataforma Bridgestone Plus seja de grande utilidade para si.<br/>Caso tenha alguma dúvida, por favor, entre em contacto connosco através do e-mail disponível na secção “Contacto”.<br/>Os melhores cumprimentos,<br/>Equipa Bridgestone Plus",
    },
  },
};

export default {
  messages,
};
